import { handleActions } from 'redux-actions';
import { push } from "react-router-redux";
import { initialize as initializeForm, change } from "redux-form";
import { api } from "api";
import { NotificationManager} from "react-notifications";


let url = 'bodega' ;
const url_inventario = 'inventario';
let form = 'TipoCategoriaForm';
let dirGrid = '/admin_tipocategoria';

export const constants ={
    LOADER: 'LOADER_EB',
    DATA: 'DATA_EB',
    ITEM: 'ITEM_EB',
    PAGE: `PAGE_EB`,
    PAGE2: `PAGE2_EB`,
    PAGE3: `PAGE3_EB`,
    PAGE_MATERIA_PRIMA: 'SET_PAGE_MATERIA_PRIMA',
    PAGE_PRODUCCION: 'SET_PAGE_PRODUCCION',
    PAGE_KARDEX: 'SET_PAGE_KARDEX',
    ORDERING: `ORDERING_EB`,
    SEARCH: `SEARCH_EB`,
    OPEN_MODAL: 'OPENMODAL_EB',
    LOADER_FORMULARIO: 'LOADER_FORMULARIO_EB',
    SET_PENDIENTES:'SET_PENDIENTES',
    SET_PRODUCTOSDS:'SET_PRODUCTOSDS',
    HISTORIA_MOVIMIENTOS: 'SET_HISTORIA_EB',
    HISTORIA_MOVIMIENTOS_DESPACHOS: 'SET_HISTORIA_DESPACHOS_EB',
    INVENTARIO_MATERIA_PRIMA: 'SET_INVENTARIO_MATERIA_PRIMA',
    INVENTARIO_PRODUCCION: 'SET_INVENTARIO_PRODUCCION',
    KARDEX_TRANSICION: 'SET_KARDEX_TRANSICION',
    ES_BODEGA_MP: 'SET_ES_BODEGA_MP',
    OPEN_MODAL_PROD: 'SET_OPEN_MODAL_PROD',
    CLASE_PRODUCTO_FILTER: 'SET_CLASE_PRODUCTO_FILTER',
    VENDIBLE_FILTER: 'SET_VENDIBLE_FILTER',
    FACTURADO_FILTER: 'SET_FACTURADO_FILTER',
    REPUESTO_FILTER: 'REPUESTO_FILTER',
    EXISTENCIAS_FILTER: 'SET_EXISTENCIAS_FILTER',
    DESPACHOS_PENDIENTES: 'DESPACHOS_PENDIENTES_EB',
    VALUE_MOVIMIENTO: 'VALUE_MOVIMIENTO_KARDEX',
    VALUE_ORIGEN: 'VALUE_ORIGEN',
    SET_TIPOS: 'PRODUCTO_TIPOS_EB',
    SET_SEARCH_TIPO: 'PRODUCTO_SET_SEARCH_TIPO_EB',
    SET_USUARIOS: 'USUARIOS_EB',
    SET_SEARCH_USUARIO: 'USUARIO_SET_EB',
    SET_DATE_START: 'SET_DATE_START_EB',
    SET_DATE_END: 'SET_DATE_END_EB',
}

const setLoader = loader =>({
    type:constants.LOADER,
    loader
})
const setLoaderFormulario = loader_formulario =>({
    type:constants.LOADER_FORMULARIO,
    loader_formulario
})

const setData = (type, data) =>({
    type,
    data
})

const setPage = page => ({
    type: constants.PAGE,
    page,
});

const setPage2 = page2 => ({
    type: constants.PAGE2,
    page2,
});

const setPageMateriaPrima = page => ({ type: constants.PAGE_MATERIA_PRIMA, page });
const setPageProduccion = page => ({ type: constants.PAGE_PRODUCCION, page });
const setPageKardex = page => ({ type: constants.PAGE_KARDEX, page });

const setPage3 = page3 => ({
    type: constants.PAGE3,
    page3,
});

const setOrdering = ordering => ({
    type: constants.ORDERING,
    ordering,
});

const setSearch = search => ({
    type: constants.SEARCH,
    search,
});

const setDataSelect = (type, data) =>({
    type,
    data
});

const listar = (page = 1, bodega) => (dispatch, getStore) => {
    const resource = getStore().estado_bodega;
    const params = { page };
    params.bodega = bodega
    params.search = resource.search;
    dispatch(setLoader(true));
    dispatch(getHistoriaMovimientos(1, bodega))
    api.get(`inventario/getInventario/${bodega}`, params).then((response) => {
        dispatch(setData(constants.DATA ,response));
        dispatch(setPage(page));
        dispatch(getHistoriaMovimientos(1, bodega))
    }).catch(() => {
    }).finally(() => {
        dispatch(setLoader(false));
    });
};


const getHistoria = (page = 1, bodega) => (dispatch, getStore) => {
    const resource = getStore().estado_bodega;
    const params = { page };
    params.bodega = bodega
    params.search = resource.search;
    dispatch(setLoader(true));

    api.get(`despachos/getHistorialBodega`, params).then((response) => {
        dispatch(setData(constants.HISTORIA_MOVIMIENTOS ,response));
        dispatch(setPage2(page));
    }).catch(() => {
    }).finally(() => {
        dispatch(setLoader(false));
    });
};

const getHistoriaMovimientos = (page = 1, bodega) => (dispatch, getStore) => {
    const resource = getStore().estado_bodega;
    const params = { page };
    params.bodega = bodega
    params.search = resource.search;
    if(resource.usuario != null){
        params.usuario = resource.usuario.value
    }
    if(resource.tipo != null){
        params.tipo = resource.tipo.value
    }
    if(resource.dateStart != null && resource.dateEnd != null){
        params.fecha_inicial = resource.dateStart.format("YYYY-MM-DD");
        params.fecha_final = resource.dateEnd.format("YYYY-MM-DD");
    }
    dispatch(setLoader(true));

    api.get(`despachos/getHistorialMovimientosBodega`, params).then((response) => {
        dispatch(setData(constants.HISTORIA_MOVIMIENTOS_DESPACHOS ,response));
        dispatch(setPage3(page));
    }).catch(() => {
    }).finally(() => {
        dispatch(setLoader(false));
    });
};

const getInventarioBodegaMateriaPrima = (page=1, bodegaId) => (dispatch, getStore) => {
    dispatch(setLoader(true));
    const resource = getStore().estado_bodega;
    const params = { page };
    params.bodegaId = bodegaId;
    params.search = resource.search;
    params.vendible = resource.vendible_filter;
    params.categoria_producto = resource.clase_producto_filter;
    params.porExistencias = resource.existencias_filter;
    params.facturado = resource.facturado_filter;
    params.repuesto = resource.repuesto_filter;

    api.get(`inventario-transicion/get_materia_prima`, params).then((response) => {
        dispatch(setData(constants.INVENTARIO_MATERIA_PRIMA, response));
        dispatch(setPageMateriaPrima(page));
    }).catch(() => {
    }).finally(() => {
        dispatch(setLoader(false));
    });
};

const getInventarioBodegaProduccion = (page=1, bodegaId) => (dispatch, getStore) => {
    dispatch(setLoader(true));
    const resource = getStore().estado_bodega;
    const params = { page };
    params.bodegaId = bodegaId;
    params.search = resource.search;
    params.categoria_producto = resource.clase_producto_filter;
    params.vendible = resource.vendible_filter;
    params.porExistencias = resource.existencias_filter;
    params.facturado = resource.facturado_filter;
    params.repuesto = resource.repuesto_filter;

    api.get(`inventario-transicion/get_produccion`, params).then((response) => {
        dispatch(setData(constants.INVENTARIO_PRODUCCION, response));
        dispatch(setPageProduccion(page));
    }).catch(() => {
    }).finally(() => {
        dispatch(setLoader(false));
    });
};

const getKardexBodegasTransicion = (page=1, bodegaId) => (dispatch, getStore) => {
    dispatch(setLoader(true));
    const resource = getStore().estado_bodega;
    const params = { page };
    params.bodegaId = bodegaId;
    params.search = resource.search;

    if (resource.valorMovimiento) params.tipo = resource.valorMovimiento.value;
    if (resource.valueOrigen) params.origen_movimiento = resource.valueOrigen.value;
    if (resource.usuario) params.idUsuario = resource.usuario.value;
    if (resource.tipo) params.idTipo = resource.tipo.value;
    if (resource.dateStart != null && resource.dateEnd != null){
        params.fecha_inicial = resource.dateStart.format("YYYY-MM-DD");
        params.fecha_final = resource.dateEnd.format("YYYY-MM-DD");
    }
    if (resource.es_bodega_mp==false) params.bodega_origen = 10;
    else params.bodega_origen = 20;

    api.get(`inventario-transicion/get_kardex`, params).then((response) => {
        dispatch(setData(constants.KARDEX_TRANSICION, response));
        dispatch(setPageKardex(page));
    }).catch(() => {
    }).finally(() => {
        dispatch(setLoader(false));
    });
};

const realizarTrasladoInventarioMP = (data, bodegaId) => (dispatch) => {
    dispatch(setLoader(true));

    data.bodegaId = bodegaId;
    api.post(`inventario-transicion/trasladar_inventario_mp`, data).then(() => {
        NotificationManager.success('Traslado realizado correctamente.', 'Éxito', 3000);
        dispatch(push(`/estado_bodega/${bodegaId}`));
        dispatch(updateAllTabs(bodegaId))
    }).catch((error) => {
        if (error && error.detail){
            NotificationManager.error(error.detail, 'ERROR');
        } else NotificationManager.error(mensaje, 'ERROR');
    }).finally(() => {
        dispatch(setLoader(false));
    });
};

const reajustarInventarioTransicion = (data, bodega) => (dispatch) => {
    dispatch(setLoaderFormulario(true));

    api.post(`despachos`, data).then(() => {
        NotificationManager.success('Registro creado', 'Éxito', 3000);
        dispatch(updateAllTabs(bodega))
    }).catch(() => {
        NotificationManager.error('Error en la creación', 'ERROR');
    }).finally(() => {
        dispatch(setLoaderFormulario(false));
        dispatch(setOpenModal(false))
        dispatch(setOpenModalProd(false))
    });
};

const searchChangeTransicion = (search, bodega, tab) => (dispatch) => {
    dispatch(setSearch(search));
    dispatch(updateAllTabs(bodega));
};

const updateAllTabs = (bodega) => (dispatch) => {
    dispatch(getInventarioBodegaMateriaPrima(1, bodega));
    dispatch(getInventarioBodegaProduccion(1, bodega));
    dispatch(getKardexBodegasTransicion(1, bodega));
};

const leer = id => (dispatch) => {
    dispatch(setLoader(true));
    api.get(`${url}/${id}`).then((response) => {
        console.log('Response, ', response);
        dispatch(setData(constants.ITEM,response));
        if (!!form)
            dispatch(initializeForm(form, response));
    }).catch(() => {
    }).finally(() => {
        dispatch(setLoader(false));
    });
};

const getDespachosPendientes = id => (dispatch, getStore) => {
    // let params = {bodega_destino: id, flujo_despacho: 10, tipo_despacho:10}
    const me = getStore().login.me
    const permisos = me.permisos;
    const params = {flujo_despacho: 10, tipo_despacho:10, bodega: id};

    if (permisos.visualizar_mis_datos && permisos.despacho_venta_interna) {
        // No filtrar sus propios datos si despacho_venta_interna esta en True
        // params.visualizar_mis_datos = false;
        params.select = false;
    } else if (permisos.visualizar_mis_datos == true) {
        params.visualizar_mis_datos = true
        params.id_user = me.id
        params.select=false
    }
    dispatch(setLoader(true));
    api.get(`despachos/getDespachosPendientesBodegas`, params).then((response) => {
        // Filtrar solo despachos que correspondan a la bodega, tomando en cuenta si son de_receta también
        // response.data = _.filter(response.data, (despacho) => {
        //     let agregar = true;
        //     despacho.detalle_despacho.forEach(detalle => {
        //         if (detalle.producto.empresa == response.id_empresa_bodega && detalle.de_receta) {
        //             agregar = false;
        //         }
        //     })
        //     if (agregar) return despacho
        // });

        // dispatch(setData(constants.DESPACHOS_PENDIENTES, pendientesList));
        dispatch(setData(constants.DESPACHOS_PENDIENTES,response.data));

    }).catch(() => {
    }).finally(() => {
        dispatch(setLoader(false));
    });
};


const crear = data => (dispatch) => {
    dispatch(setLoaderFormulario(true));
    api.post(`${url}`, data).then(() => {
        NotificationManager.success('Registro creado', 'Éxito', 3000);
        dispatch(listar());
    }).catch(() => {
        NotificationManager.error('Error en la creación', 'ERROR');
    }).finally(() => {
        dispatch(setLoaderFormulario(false));
        dispatch(setOpenModal(false))
    });
};

const editar = (id, data) => (dispatch) => {
    dispatch(setLoaderFormulario(true));
    api.put(`${url}/${id}`, data).then(() => {
        NotificationManager.success('Registro actualizado', 'Éxito', 3000);
        dispatch(listar());

    }).catch(() => {
        NotificationManager.error('Error en la edición', 'ERROR', 0);
    }).finally(() => {
        dispatch(setLoaderFormulario(false));
        dispatch(setOpenModal(false))
    });
};

const reajustar_inventario = (data, bodega) => (dispatch) => {
    dispatch(setLoaderFormulario(true));
    api.post(`despachos`, data).then(() => {
        NotificationManager.success('Registro creado', 'Éxito', 3000);
        dispatch(listar(1, bodega));
        dispatch(getHistoriaMovimientos(1, bodega))
    }).catch(() => {
        NotificationManager.error('Error en la creación', 'ERROR');
    }).finally(() => {
        dispatch(setLoaderFormulario(false));
        dispatch(setOpenModal(false))
    });
};

const eliminar = id => (dispatch) => {
    dispatch(setLoaderFormulario(true));
    api.eliminar(`${url}/${id}`).then(() => {
        dispatch(listar());

    }).catch(() => {
        NotificationManager.success('Error en la transacción', 'Éxito', 3000);
    }).finally(() => {
        dispatch(setLoaderFormulario(false));
    });
};

const searchChange = (search, bodega, bandera) => (dispatch) => {
    if (bandera == "INVENTARIO"){
        dispatch(setSearch(search));
        dispatch(listar(1, bodega));
    }
    else if (bandera =='HISTORIAL'){
        dispatch(setSearch(search));
        dispatch(getHistoria(1, bodega));
    }
    else{
        dispatch(setSearch(search));
        dispatch(getHistoriaMovimientos(1, bodega));
    }
};

const onSortChange = ordering => (dispatch, getStore) => {
    const sort = getStore().clientes.ordering;
    if (ordering === sort) {
        dispatch(setOrdering(`-${ordering}`));
    } else {
        dispatch(setOrdering(ordering));
    }
    dispatch(listar());
};


const setOpenModal = (open_modal) => (dispatch, getStore) => {
    dispatch({
        type: constants.OPEN_MODAL,
        open_modal: open_modal
    })
}
const setOpenModalProd = (open_modal_prod) => (dispatch, getStore) => {
    dispatch({
        type: constants.OPEN_MODAL_PROD,
        open_modal_prod: open_modal_prod
    })
}

const setClaseProductoFilter = (clase_producto_filter, bodega) => (dispatch, getStore) => {
    dispatch({
        type: constants.CLASE_PRODUCTO_FILTER,
        clase_producto_filter: clase_producto_filter
    });
    dispatch(getInventarioBodegaMateriaPrima(1, bodega));
    dispatch(getInventarioBodegaProduccion(1, bodega));
}

const setVendibleFilter = (vendible_filter, bodega) => (dispatch, getStore) => {
    dispatch({
        type: constants.VENDIBLE_FILTER,
        vendible_filter: vendible_filter
    });
    dispatch(getInventarioBodegaMateriaPrima(1, bodega));
    dispatch(getInventarioBodegaProduccion(1, bodega));
}

const setFacturadoFilter = (facturado_filter, bodega) => (dispatch, getStore) => {
    dispatch({
        type: constants.FACTURADO_FILTER,
        facturado_filter: facturado_filter
    });
    dispatch(getInventarioBodegaMateriaPrima(1, bodega));
    dispatch(getInventarioBodegaProduccion(1, bodega));
}

const setRepuestoFilter = (repuesto_filter, bodega) => (dispatch, getStore) => {
    dispatch({
        type: constants.REPUESTO_FILTER,
        repuesto_filter: repuesto_filter
    });
    dispatch(getInventarioBodegaMateriaPrima(1, bodega));
    dispatch(getInventarioBodegaProduccion(1, bodega));
}

const setExistenciasFilter = (existencias_filter, bodega) => (dispatch, getStore) => {
    dispatch({
        type: constants.EXISTENCIAS_FILTER,
        existencias_filter: existencias_filter
    });
    dispatch(getInventarioBodegaMateriaPrima(1, bodega));
    dispatch(getInventarioBodegaProduccion(1, bodega));
}

const setEsBodegaPM = (es_bodega_mp, id_bodega) => (dispatch, getStore) => {
    dispatch({type: constants.ES_BODEGA_MP, es_bodega_mp: es_bodega_mp});
    dispatch(getKardexBodegasTransicion(1, id_bodega));
}

const listDS = (id_bodega) => (dispatch) =>{
    dispatch(setLoader(true));
    let params = {id_bodega}
    api.get(`despachos/listds`, params).then((res)=>{
        dispatch(setData(constants.SET_PENDIENTES, res))
    }).catch((res)=>{
    }).finally(()=>{
        dispatch(setLoader(false));
    })
}

const setProductoDespacho = (parametros) => (dispatch) =>{
    dispatch(setLoader(true));
    console.log('parametros', parametros)
    let params = {...parametros}
    api.get(`despachos/getListadepacho`, params).then((res)=>{
        dispatch(setData(constants.SET_PRODUCTOSDS, res))
        let detalle = []
        res.forEach( (item, index) => {
            detalle[index] = {
                producto: item,
                despachar: item.es_bodega? item.cantidad_actual: 0
            };
        })
        dispatch(change('DespachoBodegaForm', `Despachos`, detalle))

    }).catch((res)=>{
    }).finally(()=>{
        dispatch(setLoader(false));
    })
}

const descargaArchivoInventarioBodegaEP = (bodega_transicion) => (dispatch, getStore) => {
    dispatch(setLoader(true));
    const resource = getStore().estado_bodega;

    let params = {bodegaId: resource.item.id}
    /* const params = {
        fecha_inicio: resource.fecha_inicio_ov.format("YYYY-MM-D"),
        fecha_fin: resource.fecha_fin_ov.format("YYYY-MM-D")
    }; */

    if (bodega_transicion) params.bodega_transicion = bodega_transicion
    if (resource.search) params.search = resource.search;
    if (resource.vendible_filter) params.vendible = resource.vendible_filter;
    if (resource.clase_producto_filter) params.categoria_producto = resource.clase_producto_filter;
    if (resource.existencias_filter) params.porExistencias = resource.existencias_filter;
    if (resource.facturado_filter) params.facturado = resource.facturado_filter;
    if (resource.repuesto_filter) params.repuesto = resource.repuesto_filter;

    api.get(`${url_inventario}/descargar_reporte_inventario`, params).then((response) => {
        NotificationManager.success(response.detail, 'Éxito', 5000);
        setTimeout(() => {
            dispatch(cicloVerificacion(response.id_archivo));
        }, 500);
    }).catch(() => {
        NotificationManager.error('Error en la Descarga del Reporte', 'Error', 5000);
        dispatch(setLoader(false));
    }).finally(() => {
    });
};

const cicloVerificacion = (id_archivo) => (dispatch, getStore) => {
    dispatch(setLoader(true));
    setTimeout(function () {
        dispatch(descarga_estadoEP(id_archivo));
    }, 5000)
}

const descarga_estadoEP = (id_archivo) => (dispatch, getStore) => {
    let FALLO = 0;
    let FINALIZADO = 1;
    let EN_PROCESO = 2;

    let params = { id_archivo }
    api.get(`${url_inventario}/descargar_estado`, params).then((response) => {
        if (response.estado == EN_PROCESO){
            dispatch(cicloVerificacion(id_archivo));
        }
        else if (response.estado == FINALIZADO){
            dispatch(setLoader(false));
            if (response.id) {
                // window.open(response.archivo);
                const link = document.createElement('a');
                const fileName = response.archivo.split('/').pop();

                link.href = response.archivo;
                link.download = fileName;
                document.body.appendChild(link);
                link.click();
                link.remove();
            }
        }
        else if (response.estado == FALLO){
            dispatch(setLoader(false));
            NotificationManager.error(response.motivo, 'Error', 5000);
        }
    }).catch(() => {
        NotificationManager.error('Error en la Descarga del Reporte', 'Error', 5000);
        dispatch(setLoader(false));
    }).finally(() => {
    });
};

const DespacharProducto = (data, orden, bodega) => (dispatch) => {
    dispatch(setLoader(true));
    data.orden = orden;
    data.bodega = bodega;
    api.post(`despachos/createdespachobodega`, data).then(() => {
        NotificationManager.success('Registro creado', 'Éxito', 3000);
        dispatch(reset('DespachoBodegaForm'));
        dispatch(getHistoriaMovimientos(1, bodega))
        if (!!dirGrid)
            dispatch(push(`/estado_bodega/${bodega}`));
            // dispatch(goBack())
    }).catch((error) => {
        let mensaje = 'Error en la creación del despacho';
        if(error){
            if(error.detail){
                mensaje = error.detail
            }else {
                mensaje = Object.keys(error)[0] + " " + error[Object.keys(error)[0]][0]
            }
        }
        NotificationManager.error(mensaje, 'ERROR');
    }).finally(() => {
        dispatch(setLoader(false));
    });
};

const DespachoEntreBodega = (data, bodega) => (dispatch) => {
    dispatch(setLoader(true));
    data.bodega = bodega;
    api.post(`despachos/despachoEntreBodega`, data).then(() => {
        NotificationManager.success('Registro creado', 'Éxito', 3000);
        dispatch(push(`/estado_bodega/${bodega}`));
        dispatch(getHistoriaMovimientos(1, bodega))
            // dispatch(goBack())
    }).catch((error) => {
        let mensaje = 'Error en la creación del despacho';
        if(error){
            if(error.detail){
                mensaje = error.detail
            }else {

            }
        }
        NotificationManager.error(mensaje, 'ERROR');
    }).finally(() => {
        dispatch(setLoader(false));
    });
};

const changeTipo = (tipo, id_bodega) => dispatch => {
    dispatch({type:constants.SET_SEARCH_TIPO, tipo});
    dispatch(getHistoriaMovimientos(1, id_bodega));
}

const changeTipoTransicion = (tipo, id_bodega) => dispatch => {
    dispatch({type:constants.SET_SEARCH_TIPO, tipo});
    dispatch(getKardexBodegasTransicion(1, id_bodega));
}

const changeKardexTransicionTipo = (tipo, id_bodega) => dispatch => {
    dispatch({type:constants.SET_SEARCH_TIPO, tipo});
    dispatch(getKardexBodegasTransicion(1, id_bodega));
}

const changeKardexTipoMovimiento = (valorMovimiento, id_bodega) => (dispatch, getStore) => {
    dispatch({
        type: constants.VALUE_MOVIMIENTO,
        valorMovimiento
    });
    dispatch(getKardexBodegasTransicion(1, id_bodega));
};
const changeOrigenMovimiento = (valueOrigen, id_bodega) => (dispatch, getStore) => {
    dispatch({
        type: constants.VALUE_ORIGEN,
        valueOrigen
    });
    dispatch(getKardexBodegasTransicion(1, id_bodega));
};

const selectTipos = () => (dispatch) =>{
    dispatch(setLoader(true));
    api.get('tipoproducto/selecttipos').then((res)=>{
        dispatch(setDataSelect(constants.SET_TIPOS, res))
    }).catch(()=>{
    }).finally(()=>{
        dispatch(setLoader(false))
    })
}

const changeUsuario = (usuario, id_bodega) => dispatch => {
    dispatch({type:constants.SET_SEARCH_USUARIO, usuario});
    dispatch(getHistoriaMovimientos(1, id_bodega));
}

const changeUsuarioTransicion = (usuario, id_bodega) => dispatch => {
    dispatch({type:constants.SET_SEARCH_USUARIO, usuario});
    dispatch(getKardexBodegasTransicion(1, id_bodega));
}

const selectUsuarios = () => (dispatch) =>{
    dispatch(setLoader(true));
    api.get('user/selectusuarios').then((res)=>{
        dispatch(setDataSelect(constants.SET_USUARIOS, res))
    }).catch(()=>{
    }).finally(()=>{
        dispatch(setLoader(false))
    })
}

const setDateStart = (value, id_bodega) => (dispatch) => {
    dispatch({type: constants.SET_DATE_START, dateStart: value})
    dispatch(getHistoriaMovimientos(1, id_bodega));
}

const setDateEnd = (value, id_bodega) => (dispatch) => {
    dispatch({type: constants.SET_DATE_END, dateEnd: value})
    dispatch(getHistoriaMovimientos(1, id_bodega));
}

const setDateStartTransicion = (value, id_bodega) => (dispatch) => {
    dispatch({type: constants.SET_DATE_START, dateStart: value})
    dispatch(getKardexBodegasTransicion(1, id_bodega));
}

const setDateEndTransicion = (value, id_bodega) => (dispatch) => {
    dispatch({type: constants.SET_DATE_END, dateEnd: value})
    dispatch(getKardexBodegasTransicion(1, id_bodega));
}


export const actions = {
    listar,
    leer,
    crear,
    editar,
    eliminar,
    searchChange,
    onSortChange,
    setOpenModal,
    reajustar_inventario,
    listDS,
    setProductoDespacho,
    DespacharProducto,
    getHistoria,
    getDespachosPendientes,
    DespachoEntreBodega,
    getHistoriaMovimientos,
    getInventarioBodegaMateriaPrima,
    getInventarioBodegaProduccion,
    getKardexBodegasTransicion,
    searchChangeTransicion,
    realizarTrasladoInventarioMP,
    reajustarInventarioTransicion,
    setOpenModalProd,
    setEsBodegaPM,
    setClaseProductoFilter,
    setVendibleFilter,
    setFacturadoFilter,
    setRepuestoFilter,
    setExistenciasFilter,
    changeTipo,
    changeTipoTransicion,
    changeKardexTipoMovimiento,
    changeOrigenMovimiento,
    changeKardexTransicionTipo,
    selectTipos,
    descargaArchivoInventarioBodegaEP,
    changeUsuario,
    changeUsuarioTransicion,
    selectUsuarios,
    setDateStartTransicion,
    setDateEndTransicion,
    setDateStart,
    setDateEnd
};


export const reducers ={
    [constants.LOADER]:(state,{loader}) =>{
        return{
            ...state,
            loader,
        };
    },
    [constants.DATA]:(state,{data}) => {
        return{
            ...state,
            data
        }
    },
    [constants.ITEM]: (state, { data }) => {
        return {
            ...state,
            item: data,
        };
    },
    [constants.PAGE]: (state, { page }) => {
        return {
            ...state,
            page,
        };
    },
    [constants.PAGE2]: (state, { page2 }) => {
        return {
            ...state,
            page2,
        };
    },
    [constants.PAGE3]: (state, { page3 }) => {
        return {
            ...state,
            page3,
        };
    },
    [constants.PAGE_MATERIA_PRIMA]: (state, { page }) => ({ ...state, page_materia_prima: page }),
    [constants.PAGE_PRODUCCION]: (state, { page }) => ({ ...state, page_produccion: page }),
    [constants.PAGE_KARDEX]: (state, { page }) => ({ ...state, page_kardex: page }),
    [constants.ORDERING]: (state, { ordering }) => {
        return {
            ...state,
            ordering,
        };
    },
    [constants.SEARCH]: (state, { search }) => {
        return {
            ...state,
            search,
        };
    },
    [constants.OPEN_MODAL]: (state, { open_modal }) => {
        return {
            ...state,
            open_modal,
        };
    },
    [constants.OPEN_MODAL_PROD]: (state, { open_modal_prod }) => {
        return {
            ...state,
            open_modal_prod,
        };
    },
    [constants.CLASE_PRODUCTO_FILTER]: (state, { clase_producto_filter }) => {
        return {
            ...state,
            clase_producto_filter,
        };
    },
    [constants.VENDIBLE_FILTER]: (state, { vendible_filter }) => {
        return {
            ...state,
            vendible_filter,
        };
    },
    [constants.FACTURADO_FILTER]: (state, { facturado_filter }) => {
        return {
            ...state,
            facturado_filter,
        };
    },
    [constants.REPUESTO_FILTER]: (state, { repuesto_filter }) => {
        return {
            ...state,
            repuesto_filter,
        };
    },
    [constants.EXISTENCIAS_FILTER]: (state, { existencias_filter }) => {
        return {
            ...state,
            existencias_filter,
        };
    },
    [constants.ES_BODEGA_MP]: (state, { es_bodega_mp }) => {
        return {
            ...state,
            es_bodega_mp,
        };
    },
    [constants.VALUE_MOVIMIENTO]:(state,{ valorMovimiento })=>{
        return{
            ...state,
            valorMovimiento,
        }
    },
    [constants.VALUE_ORIGEN]:(state,{ valueOrigen })=>{
        return{
            ...state,
            valueOrigen,
        }
    },
    [constants.LOADER_FORMULARIO]: (state, { loader_formulario }) => {
        return {
            ...state,
            loader_formulario,
        };
    },
    [constants.SET_PENDIENTES]:(state,{ data })=>{
        return{
            ...state,
            pendientes: data,
        }
    },
    [constants.SET_PRODUCTOSDS]:(state,{ data })=>{
        return{
            ...state,
            productosDS: data,
        }
    },
    [constants.HISTORIA_MOVIMIENTOS]:(state,{ data })=>{
        return{
            ...state,
            historia_movimientos: data,
        }
    },
    [constants.HISTORIA_MOVIMIENTOS_DESPACHOS]:(state,{ data })=>{
        return{
            ...state,
            historia_movimientos_despachos: data,
        }
    },
    [constants.INVENTARIO_MATERIA_PRIMA]:(state,{ data })=>{
        return{
            ...state,
            inventario_materia_prima: data,
        }
    },
    [constants.INVENTARIO_PRODUCCION]:(state,{ data })=>{
        return{
            ...state,
            inventario_produccion: data,
        }
    },
    [constants.KARDEX_TRANSICION]:(state,{ data })=>{
        return{
            ...state,
            kardex_transicion: data,
        }
    },
    [constants.DESPACHOS_PENDIENTES]:(state,{ data })=>{
        return{
            ...state,
            despachos_pendientes: data,
        }
    },
    [constants.SET_TIPOS]:(state,{ data })=>{
        return{
            ...state,
            tipos: data.tipo,
        }
    },
    [constants.SET_SEARCH_TIPO]: (state, {tipo}) => {
        return {
            ...state,
            tipo
        }
    },
    [constants.SET_ES_BODEGA_MP]: (state, {es_bodega_mp}) => {
        return {
            ...state,
            es_bodega_mp
        }
    },
    [constants.SET_USUARIOS]:(state,{ data })=>{
        return{
            ...state,
            usuarios: data.usuario,
        }
    },
    [constants.SET_SEARCH_USUARIO]: (state, {usuario}) => {
        return {
            ...state,
            usuario
        }
    },
    [constants.SET_DATE_START]: (state, { dateStart }) => {
        return {
            ...state,
            dateStart
        }
    },
    [constants.SET_DATE_END]: (state, { dateEnd }) => {
        return {
            ...state,
            dateEnd
        }
    },
};


export const initialState ={
    loader:false,
    data: [],
    item: {nombre: ''},
    page: 1,
    page2: 1,
    page3: 1,
    page_materia_prima: 1,
    page_produccion: 1,
    page_kardex: 1,
    ordering: '',
    search: '',
    open_modal: false,
    loader_formulario: false,
    pendientes:[],
    productosDS:[],
    historia_movimientos:{
        results: [],
        count: 0
    },
    historia_movimientos_despachos:{
        results: [],
        count: 0
    },
    inventario_materia_prima: {
        results: [],
        count: 0
    },
    inventario_produccion: {
        results: [],
        count: 0
    },
    kardex_transicion: {
        results: [],
        count: 0
    },
    valorMovimiento: null,
    valueOrigen: null,
    open_modal_prod: false,
    clase_producto_filter: 0,
    vendible_filter: 0,
    facturado_filter: 0,
    repuesto_filter: 0,
    existencias_filter: 0,
    es_bodega_mp: false,
    despachos_pendientes: [],
    tipo: null,
    tipos: [],
    usuario: null,
    usuarios: [],
    dateStart: null,
    dateEnd: null,
};

export default handleActions(reducers, initialState);
